var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
import { UserWithoutRelationsDto } from '../../../classes/user/response/user-without-relations.dto';
import { VendorWithoutRelationsDto } from '../../../classes/vendor';
/**
 * A preallocation list row without its blocks. The block count and date
 * range cover live blocks, narrowed by the vehicle model type filter when
 * one is given, so they match the blocks of the full list response.
 */
export class PreallocationSummaryDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.name = initializer.name;
        this.memo = initializer.memo;
        this.manager = initializer.manager;
        this.managerId = initializer.managerId;
        this.vendors = initializer.vendors;
        this.blockCount = initializer.blockCount;
        this.blockStartDate = initializer.blockStartDate;
        this.blockEndDate = initializer.blockEndDate;
    }
}
__decorate([
    Type(() => UserWithoutRelationsDto),
    __metadata("design:type", UserWithoutRelationsDto)
], PreallocationSummaryDto.prototype, "manager", void 0);
__decorate([
    Type(() => VendorWithoutRelationsDto),
    __metadata("design:type", Array)
], PreallocationSummaryDto.prototype, "vendors", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], PreallocationSummaryDto.prototype, "blockStartDate", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], PreallocationSummaryDto.prototype, "blockEndDate", void 0);
